import React, { Fragment, useState, useEffect } from 'react'
import { gtmEvent } from '../Services/DataLayerAddOrRemoveCart'

const QuantityChanger = ({
    quantity,
    updateQuantity,
    rowSystemId,
    maxQuantity,
}) => {
    const useMaxQuantity = !Number.isNaN(Number(maxQuantity))

    const [updatedQuantity, setQuantity] = useState()
    const [timer, setTimer] = useState()

    useEffect(() => {
        setQuantity(
            useMaxQuantity
                ? Math.min(Number(quantity), Number(maxQuantity))
                : quantity
        )
    }, [quantity])

    const handleChangeQuantity = (q, gtmType) => {
        setQuantity(q)
        clearTimeout(timer)

        setTimer(
            setTimeout(() => {
                updateQuantity(q)
                gtmEvent(gtmType, rowSystemId)
            }, 500)
        )
    }

    return (
        <Fragment>
            <div className="quantity-changer">
                <div
                    className={`quantity-changer__button ${
                        Number(updatedQuantity) === 1 ? 'disabled' : ''
                    }`}
                    onClick={() =>
                        handleChangeQuantity(updatedQuantity - 1, 'remove')
                    }
                >
                    &ndash;
                </div>
                <div className="quantity-changer__quantity-text">
                    {updatedQuantity}
                </div>
                <div
                    className={`quantity-changer__button ${
                        Number(updatedQuantity) >= 20 ||
                        (useMaxQuantity &&
                            updatedQuantity === Number(maxQuantity))
                            ? 'disabled'
                            : ''
                    }`}
                    onClick={() =>
                        handleChangeQuantity(updatedQuantity + 1, 'add')
                    }
                >
                    +
                </div>
            </div>
        </Fragment>
    )
}

export default QuantityChanger
